import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

// ----------------------
// Dashboard Component
// ----------------------
const Dashboard = () => {
  // State for summary cards
  const [totalStudents, setTotalStudents] = useState(0);
  const [totalCourses, setTotalCourses] = useState(0);
  const [totalCategories, setTotalCategories] = useState(0); 

  // Fetch total students, courses, and categories from Firestore
  useEffect(() => {
    const fetchStudents = async () => {
      const querySnapshot = await getDocs(collection(db, "students"));
      setTotalStudents(querySnapshot.size);
    };
    const fetchCourses = async () => {
      const querySnapshot = await getDocs(collection(db, "courses"));
      setTotalCourses(querySnapshot.size);
    };
    const fetchCategories = async () => {
      const querySnapshot = await getDocs(collection(db, "courseCategories"));
      setTotalCategories(querySnapshot.size);
    };
    fetchStudents();
    fetchCourses();
    fetchCategories();
  }, []);

  // Summary card data
  const summaryCards = [
    {
      title: "Total Students",
      value: totalStudents,
      icon: <i className="bi bi-people-fill fs-2 text-primary"></i>,
      
    },
    {
      title: "Active Courses",
      value: totalCourses,
      icon: <i className="bi bi-journal-richtext fs-2 text-success"></i>,
      
    },
    {
      title: "Total Categories",
      value: totalCategories,
      icon: <i className="bi bi-tags-fill fs-2 text-warning"></i>,
      
    },
  ];

  // ----------------------
  // Render
  // ----------------------
  return (
    <div className="container-fluid py-4 px-4 bg-light min-vh-100">
      {/* Dashboard Header */}
      <div className="mb-3">
        <h2 className="fw-bold mb-1">Dashboard</h2>
        <div className="text-muted">Overview of your internship management system</div>
      </div>

      {/* Summary Cards */}
      <div className="row g-3 mb-4">
        {summaryCards.map((card, idx) => (
          <div className="col-md-4 col-12" key={idx}>
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body d-flex flex-column justify-content-between align-items-center text-center">
                <div className="mb-2">{card.icon}</div>
                <span className="fw-semibold text-secondary small mb-1">{card.title}</span>
                <div className="fw-bold fs-2 mb-1 w-100 d-flex justify-content-center align-items-center" style={{minHeight: '48px'}}>{card.value}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;